import { Button, PageStatus as SharedPageStatus } from 'corso-admin-ui';
import { ComponentProps, useEffect } from 'react';
import { NavLink, useLocation, useRouteError } from 'react-router-dom';
import { useIsWidgetAuth } from '~/providers/AutoAuthProvider';

/** @deprecated We should ideally remove this wrapper and just use the `PageStatus` from `corso-admin-ui` directly, and resolve the `isWidgetAuth` case. */
export default function PageStatus({
  children,
  ...props
}: ComponentProps<typeof SharedPageStatus>) {
  const isWidgetAuth = useIsWidgetAuth();

  return (
    // oxlint-disable-next-line react/jsx-props-no-spreading
    <SharedPageStatus {...props}>
      {/* // TODO review alternatives to this, or just document that the `children` aren't rendered for token auth */}
      {!isWidgetAuth && <div className="self-stretch">{children}</div>}
    </SharedPageStatus>
  );
}

function PageStatusLoading({
  title = 'Loading',
  detail = 'Please wait while we load the page.',
}: {
  title?: string;
  detail?: string;
}) {
  return (
    <PageStatus
      icon="spinner"
      iconClassName="animate-spin"
      title={title}
      detail={detail}
    />
  );
}

PageStatus.Loading = PageStatusLoading;

/** Displays an error page, while also logging the `error` or any route errors. */
function PageStatusError({
  title = 'Something went wrong',
  detail = 'We encountered an unexpected issue.',
  error,
}: {
  title?: string;
  detail?: string;
  error?: unknown;
}) {
  const location = useLocation();
  const routeError = useRouteError(); // ? maybe try to parse to see if we have a user-friendly error available too

  useEffect(() => {
    if (!routeError) return;
    console.error(routeError);
  }, [routeError]);

  useEffect(() => {
    if (!error) return;
    console.error(error);
  }, [error]);

  return (
    <PageStatus
      title={title}
      detail={`${detail} Try reloading this page or contact our support team if the problem persists.`}
      icon="error"
    >
      <div className="flex flex-col gap-2">
        <Button asChild size="lg">
          <NavLink to={location.pathname} replace reloadDocument>
            Reload
          </NavLink>
        </Button>
        <Button asChild variant="link">
          {/* // ? maybe support going to /:storeId */}
          <NavLink to="/" replace reloadDocument>
            Go to Home
          </NavLink>
        </Button>
      </div>
    </PageStatus>
  );
}

PageStatus.Error = PageStatusError;
